import { GDTApiErrors } from '@/types';
import { ResponseRankingHistoric } from '@/types/team';
import {
  RequestNewInsured,
  RequestTranferF5,
  ResponseInitMyF5,
  ResponseNewInsured,
  ResponseTransferF5,
} from '@/types/teamf5';
import { TEXTS, URLs, axiosErrorHandler } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

const headers = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
};

export const getCurrentTeamF5 = axiosErrorHandler(async () => {
  const response = await axiosGdt.get<ResponseInitMyF5 | GDTApiErrors>(
    URLs.EQUIPO_5.INIT
  );

  return response.data;
}, TEXTS.defaultError);

export const requestTransferF5 = axiosErrorHandler(
  async (dataTransfer: RequestTranferF5) => {
    const url = URLs.EQUIPO_5.HACER_TRANFERENCIA;
    const response = await axiosGdt.post<ResponseTransferF5>(
      url,
      dataTransfer,
      headers
    );
    return response.data;
  },
  TEXTS.defaultError
);

export const requestNewInsuredF5 = axiosErrorHandler(
  async (data: RequestNewInsured) => {
    const url = URLs.EQUIPO_5.HACER_ASEGURADO;
    const response = await axiosGdt.post<ResponseNewInsured>(
      url,
      data,
      headers
    );
    return response.data;
  },
  TEXTS.defaultError
);

export const getDataRankingF5 = axiosErrorHandler(async (date: string) => {
  const url = `${URLs.EQUIPO_5.RANKING}&fecha=${encodeURIComponent(date)}`;
  const response = await axiosGdt.post<ResponseRankingHistoric>(url);
  return response.data;
}, TEXTS.defaultError);
